<template>
    <QuantityAdjustment></QuantityAdjustment>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const QuantityAdjustment = defineAsyncComponent(() =>
    import("../../components/Logistics/QuantityAdjustment.vue")
);
export default {
    name: "Logistics_QuantityAdjustment",
    components: { QuantityAdjustment, AuthLayout },
};
</script>
